import { Group, Select, MultiSelect, Button, Box, Collapse, SegmentedControl } from '@mantine/core'
import { IconCheck, IconX } from '@tabler/icons-react'

export interface TenantFilters {
  environment: string[] | null
  status: string | null
  compliance: string | null
}

export const EMPTY_FILTERS: TenantFilters = { environment: null, status: null, compliance: null }

export function countActiveFilters(filters: TenantFilters): number {
  let count = 0
  if (filters.environment && filters.environment.length > 0) count++
  if (filters.status) count++
  if (filters.compliance) count++
  return count
}

const ENV_OPTIONS = [
  { value: 'prd', label: 'Produção' },
  { value: 'stg', label: 'Staging' },
  { value: 'hml', label: 'Homologação' },
  { value: 'qa', label: 'QA' },
  { value: 'dev', label: 'Dev' },
  { value: 'sandbox', label: 'Sandbox' },
]

const STATUS_OPTIONS = [
  { value: 'active', label: 'Ativo' },
  { value: 'inactive', label: 'Inativo' },
]

const COMPLIANCE_OPTIONS = [
  { value: 'terraform', label: 'Terraform' },
  { value: 'waf', label: 'WAF' },
  { value: 'pci', label: 'PCI' },
  { value: 'pentest', label: 'Pentest' },
  { value: 'soc', label: 'SOC' },
  { value: 'zabbix', label: 'Zabbix' },
  { value: 'gitlab', label: 'GitLab' },
  { value: 'whatsapi', label: 'WhatsApi' },
]

export interface TenantsFilterPanelProps {
  opened: boolean
  filters: TenantFilters
  onFiltersChange: (filters: TenantFilters) => void
  onApply: () => void
  onClear: () => void
}

export function TenantsFilterPanel({
  opened,
  filters,
  onFiltersChange,
  onApply,
  onClear,
}: TenantsFilterPanelProps) {
  return (
    <Collapse in={opened}>
      <Box
        p="md"
        style={{
          background: 'var(--ai-border-light, #e6f3f5)',
          border: '1px solid var(--ai-border-medium, #b3dce2)',
          borderRadius: 'var(--mantine-radius-md)',
        }}
      >
        <Group align="end" gap="md">
          <MultiSelect
            label="Ambiente"
            placeholder="Todos"
            data={ENV_OPTIONS}
            value={filters.environment ?? []}
            onChange={(value) =>
              onFiltersChange({ ...filters, environment: value.length > 0 ? value : null })
            }
            clearable
            size="sm"
            style={{ minWidth: 220 }}
          />
          <Select
            label="Status"
            placeholder="Todos"
            data={STATUS_OPTIONS}
            value={filters.status}
            onChange={(value) => onFiltersChange({ ...filters, status: value })}
            clearable
            size="sm"
            style={{ minWidth: 140 }}
          />
          <Select
            label="Compliance"
            placeholder="Todos"
            data={COMPLIANCE_OPTIONS}
            value={filters.compliance}
            onChange={(value) => onFiltersChange({ ...filters, compliance: value })}
            clearable
            size="sm"
            style={{ minWidth: 160 }}
          />
          <Button size="sm" leftSection={<IconCheck size={14} />} onClick={onApply}>
            Aplicar
          </Button>
          <Button
            size="sm"
            variant="outline"
            leftSection={<IconX size={14} />}
            onClick={onClear}
          >
            Limpar
          </Button>
        </Group>
      </Box>
    </Collapse>
  )
}
